export default class Input {
    constructor(element, callback, options) {
        this.element = element;
        this.callback = callback;
        this.options = { enable: true, ...options };
    }
}
//# sourceMappingURL=input.js.map


// WEBPACK FOOTER //
// ./~/mjolnir.js/dist/esm/inputs/input.js